import { Box, Stack, CircularProgress } from '@mui/material';
import { useSkin } from '../../contexts/SkinContext';
import { useSkinStyles } from '../../hooks/useSkinStyles';
import { LOADER_CONTAINER_SKIN_STYLES, SKIN_SPINNER_MAP } from '../../styles/components/loaderContainer';

export const LoaderContainer = ({ size }: { size?: number }) => {
  const styles = useSkinStyles(LOADER_CONTAINER_SKIN_STYLES);
  const { skin } = useSkin();
  const spinnerSrc = SKIN_SPINNER_MAP[skin];

  return (
    <Stack sx={styles.container}>
      {spinnerSrc ? (
        <Box sx={styles.spinnerBox}>
          <Box component='img' src={spinnerSrc} alt='' sx={styles.spinnerImg} />
        </Box>
      ) : (
        <CircularProgress sx={styles.progress} size={size} />
      )}
    </Stack>
  );
};
